import type { AxiosResponse } from 'axios'
import { bffHTTP } from '@/utils/http/axios'
import { handleAPIException, handleExceptionNormal } from '@/utils/exception'
import { HTTPMethodsEnum } from '@/enums'

import type {
  QueryDirectCorpListModel,
  QueryDirectFileListModel,
  PostSendDirectParameters,
} from './model/sendDirectModel'
import type { Params } from '@/store/modules/direct-send/state'
import type { CorpParams } from '@/store/modules/direct-corp-list/state'

/**
 * @description ドキュメント公開企業一覧取得 API
 * @param params
 * @returns
 */
export async function queryDirectCorpList(
  params: CorpParams
): Promise<QueryDirectCorpListModel | undefined> {
  try {
    const response: AxiosResponse<QueryDirectCorpListModel, any> = await bffHTTP({
      method: HTTPMethodsEnum.GET,
      url: '/corporates/direct/public_list',
      params,
    })
    handleAPIException(response)
    return response.data
  } catch (error) {
    console.log('queryDirectCorpList', error)
  }
}

/**
 * @description 公開ドキュメント一覧取得 API
 * @param params
 * @returns
 */
export async function queryDirectFileList(
  params: Params
): Promise<QueryDirectFileListModel | undefined> {
  try {
    const response: AxiosResponse<QueryDirectFileListModel, any> = await bffHTTP({
      method: HTTPMethodsEnum.GET,
      url: '/products/documents/direct/public_list',
      params,
    })
    handleAPIException(response)
    return response.data
  } catch (error) {
    console.log('queryDirectFileList', error)
  }
}

/**
 * @description 公開ドキュメント送信 API
 * @param params
 * @returns
 */
export async function postDirectSend(
  params: PostSendDirectParameters,
): Promise<boolean> {
  try {

    const response: AxiosResponse<null, PostSendDirectParameters> = await bffHTTP({
      method: HTTPMethodsEnum.POST,
      url: '/trust/transactions/direct/public_doc',
      data: params,
    })

    handleAPIException(response)

    return true
  } catch (error) {
    console.log('postDirectSend', error)
    return false
  }
}